<template>
  <div class="progress-box">
    <div class="statusList" v-for="count in list" :key="count + 'status'">
      <div
        v-if="count % 2 == 1"
        class="status"
        :style="{
          background:
            (count / 2).toFixed(0) <= currentStatus ? '#3377FF' : '#C2C5CC',
        }"
      >
        {{ (count / 2).toFixed(0) }}
        <div class="statusText">
          {{ getStatusText((count / 2).toFixed(0)) }}
        </div>
      </div>
      <div
        v-else
        class="status-line"
        :style="{
          background: count / 2 < currentStatus ? '#3377FF' : '#C2C5CC',
        }"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "regist-progress",
  data() {
    return {};
  },
  props: {
    statusList: {
      type: Array,
      default() {
        return [];
      },
    },
    currentStatus: {
      type: Number,
      default() {
        return 1;
      },
    },
  },
  computed: {
    list() {
      if (this.statusList.length > 0) {
        return this.statusList.length + (this.statusList.length - 1);
      }
      return [];
    },
  },
  methods: {
    getStatusText(index) {
      return this.statusList[index - 1];
    },
  },
};
</script>
<style lang="scss">
.progress-box {
  width: 100%;
  padding: vw(56) 0 vw(106) 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  .statusList {
    .status {
      position: relative;
      border-radius: 50%;
      width: vw(44);
      height: vw(44);
      line-height: vw(44);
      background-color: #c2c5cc;
      color: #ffffff;
      font-size: vw(24);
      text-align: center;

      .statusText {
        position: absolute;
        bottom: vw(-50);
        left: vw(-58);
        color: #333333;
        font-size: vw(24);
        width: vw(160);
        text-align: center;
      }
    }
    .status-line {
      background-color: #c2c5cc;
      height: vw(2);
      width: vw(160);
    }
  }
}
</style>
